module.exports = __webpack_public_path__ + "img/73_16.2cb2bc76.png";